module.exports = __webpack_public_path__ + "static/classeditor-suggestions-9a596956e6209a5fceb3c8f3117eeab1.png";